import { useState, useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import useLocalStorageState from "../hooks/useLocalStorageState";
import OktaSignInWidget from "./OktaSignInWidget";
import { useOktaAuth } from "../../OktaFacade";

const Login = ({ baseUrl }) => {
  const { authState, authService } = useOktaAuth();
  const [authenticated, setAuthenticated] = useState(null);
  const query = new URLSearchParams(useLocation().search);
  const redirectUrl = query.get("fromURI");
  const [, setUberallRedirectUrl] = useLocalStorageState("uberallRedirectUrl");

  useEffect(() => {
    if (authState.isAuthenticated) {
      setAuthenticated(true);
      const accessToken = authState.accessToken?.accessToken;
      if (accessToken) {
        localStorage.setItem("accessToken", accessToken);
      }
    }
  }, [authState, authService]);

  const onSuccess = async (res) => {
    if (res.status === "SUCCESS") {
      const sessionToken = res.session.token;
      if (redirectUrl) {
        setUberallRedirectUrl(redirectUrl);
      }

      try {
        // Redirect using Okta’s authService
        await authService.redirect({ sessionToken });

        // ✅ Optionally store session token too (short-lived)
        localStorage.setItem("sessionToken", sessionToken);
      } catch (error) {
        console.error("Redirect error:", error);
      }
    } else {
      console.error("Invalid login response status:", res.status);
    }
  };

  const onError = (err) => {
    console.error("Error logging in", err);
  };

  return authenticated ? (
    <Redirect to={{ pathname: "/" }} />
  ) : (
    <OktaSignInWidget
      baseUrl={baseUrl}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
};

export default Login;
